<div class="start-page">
  <div class="actions">
    <a (click)="checkClasses()">Достижения</a>
    <a [routerLink]="[APP_PATH.teacher.analysis]">Статистика</a>
  </div>

  <ng-container *ngIf="isClasses">
    <div class="classes">
      <h4>Выберите класс или группу</h4>
      <mat-form-field>
        <mat-select>
          <mat-option *ngFor="let item of classes" [value]="item" (click)="selectClass(item.id)">
            {{ item.title }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      </div>
  </ng-container>
</div>
